/**
 * Technotrade Checkout Autofill v2 — B2B GSTIN Profile
 * Reads localStorage tt_b2b_verified and autofills Shopify checkout fields.
 * Works with Shopify's React-based checkout (uses nativeInputValueSetter).
 * Loaded globally via custom-overrides.js.
 */
(function() {
  'use strict';

  var STORAGE_KEY = 'tt_b2b_verified';

  function getB2BProfile() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (d.verified_at) {
        var age = Date.now() - new Date(d.verified_at).getTime();
        if (age > 90 * 24 * 60 * 60 * 1000) return null; // 90 day expiry
      }
      return (d.company_name || d.first_name) ? d : null;
    } catch(e) { return null; }
  }

  // React-compatible field fill — uses nativeInputValueSetter to trigger React state
  function fillField(el, value) {
    if (!el || !value || !value.trim()) return false;
    try {
      var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      setter.call(el, value);
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    } catch(e) { return false; }
  }

  // Try multiple selectors, fill first visible non-hidden match
  function fillBest(selectors, value) {
    for (var i = 0; i < selectors.length; i++) {
      var els = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        // Skip hidden autofill helper inputs (e.g. autofill_city)
        if (el.id && el.id.indexOf('autofill_') === 0) continue;
        if (el.type === 'hidden') continue;
        if (fillField(el, value)) return true;
      }
    }
    return false;
  }

  function autofillCheckout(profile) {
    if (!profile) return;
    var filled = {
      company:   fillBest(['input[name="company"]', 'input[autocomplete~="organization"]'], profile.company_name),
      firstName: fillBest(['input[name="firstName"]', 'input[autocomplete~="given-name"]'], profile.first_name),
      lastName:  fillBest(['input[name="lastName"]', 'input[autocomplete~="family-name"]'], profile.last_name),
      city:      fillBest(['input[name="city"]', 'input[autocomplete~="address-level2"]'], profile.city),
      gstin:     fillBest(['input[name="address2"]', 'input[autocomplete~="address-line2"]'], profile.gstin)
    };
    var anyFilled = filled.company || filled.firstName || filled.lastName || filled.city || filled.gstin;
    if (anyFilled) {
      console.log('[TT Autofill] Checkout filled:', filled, 'for:', profile.company_name);
      try { window.dispatchEvent(new CustomEvent('b2b:autofilled', { detail: { profile: profile, filled: filled }, bubbles: true })); } catch(e) {}
    } else {
      console.log('[TT Autofill] Fields found but all non-empty — skipped overwrite.');
    }
    return filled;
  }

  function isCheckoutPage() {
    return location.pathname.indexOf('/checkouts') !== -1 || location.pathname.indexOf('/checkout') !== -1;
  }

  // Retry with MutationObserver until company field appears (React renders async)
  function waitForFieldAndFill(profile) {
    var attempts = 0;
    var maxAttempts = 40; // 40 x 250ms = 10s max
    
    function tryFill() {
      attempts++;
      var companyField = document.querySelector('input[name="company"], input[name="firstName"]');
      if (companyField) {
        autofillCheckout(profile);
        return;
      }
      if (attempts < maxAttempts) {
        setTimeout(tryFill, 250);
      }
    }
    tryFill();
  }

  window.addEventListener('b2b:verified', function() {
    console.log('[TT Autofill] b2b:verified received — stored for checkout');
  });

  function init() {
    if (!isCheckoutPage()) return;
    var profile = getB2BProfile();
    if (!profile) { console.log('[TT Autofill] No B2B profile in localStorage.'); return; }
    console.log('[TT Autofill] Profile found, autofilling for:', profile.company_name);
    waitForFieldAndFill(profile);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

  // Also handle Shopify checkout SPA navigation events
  document.addEventListener('page:load', init);
  document.addEventListener('page:change', init);
})();